import template from './selectOption.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onDialogSelectOption(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                icon: _params.icon || 'radio_button_checked',
                title: _params.title,
                fieldTitle: _params.fieldTitle || 'Select',
                options: _params.options,
                selected: _params.selected
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (selected) {
              if (ctrl.onFinished) {
                ctrl.onFinished({ result: { id: _params.id, selected: selected } });
              }
            });

          function dialogController($mdDialog, icon, title, fieldTitle, options, selected) {
            this.icon = icon;
            this.title = title;
            this.fieldTitle = fieldTitle;
            this.options = options;
            this.selected = selected;
            this.confirm = function () {
              $mdDialog.hide(this.selected);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
